// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d_Jvq","top":"styles_top__svHNd","left":"styles_left__2e-gP","description":"styles_description__1GQ_k"};